

export const restartTour = (step:string) => {
  console.log({step})
  localStorage.removeItem(step);
  
};
